export default "__VITE_ASSET__DWOLm$19__"